"use client";
import { cn as e } from "../../lib/utils.js";
import { CheckIcon as t, SelectorIcon as n } from "../../icons.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { Select as a } from "@base-ui/react/select";
//#region src/components/Select/Select.tsx
function o(e) {
	return /* @__PURE__ */ r(a.Root, { ...e });
}
function s({ className: t, children: o, ...s }) {
	return /* @__PURE__ */ i(a.Trigger, {
		"data-slot": "select-trigger",
		className: e("border-ic-web-border bg-ic-web-background font-ic-web-body text-ic-web-heading hover:bg-ic-web-background-muted focus-visible:ring-ic-web-primary/40 data-popup-open:border-ic-web-primary flex h-8 w-full cursor-pointer items-center justify-between gap-2 rounded-md border border-solid py-2 pr-1 pl-3 text-sm whitespace-nowrap shadow-xs transition-colors select-none focus-visible:ring-2 focus-visible:outline-none data-disabled:cursor-not-allowed data-disabled:opacity-50", t),
		...s,
		children: [o, /* @__PURE__ */ r(a.Icon, {
			className: "text-ic-web-text-muted flex shrink-0",
			children: /* @__PURE__ */ r(n, { className: "size-4" })
		})]
	});
}
function c({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Value, {
		"data-slot": "select-value",
		className: e("data-placeholder:text-ic-web-text-muted truncate", t),
		...n
	});
}
function l({ className: t, children: n, side: i = "bottom", align: o = "start", sideOffset: s = 4, alignItemWithTrigger: c = !1, ...l }) {
	return /* @__PURE__ */ r(a.Portal, { children: /* @__PURE__ */ r(a.Positioner, {
		className: "ic-web-z-popover outline-none",
		side: i,
		align: o,
		sideOffset: s,
		alignItemWithTrigger: c,
		children: /* @__PURE__ */ r(a.Popup, {
			"data-slot": "select-content",
			className: e("border-ic-web-border bg-ic-web-background font-ic-web-body text-ic-web-heading min-w-(--anchor-width) origin-(--transform-origin) rounded-md border border-solid shadow-md transition-[scale,opacity] duration-100 outline-none data-ending-style:scale-95 data-ending-style:opacity-0 data-starting-style:scale-95 data-starting-style:opacity-0", t),
			...l,
			children: /* @__PURE__ */ r(a.List, {
				className: "max-h-(--available-height) overflow-y-auto p-1",
				children: n
			})
		})
	}) });
}
function u({ className: n, children: o, ...s }) {
	return /* @__PURE__ */ i(a.Item, {
		"data-slot": "select-item",
		className: e("data-highlighted:bg-ic-web-background-muted relative flex w-full cursor-default items-center rounded-sm py-1.5 pr-8 pl-2 text-sm outline-none select-none data-disabled:pointer-events-none data-disabled:opacity-50", n),
		...s,
		children: [/* @__PURE__ */ r(a.ItemText, { children: o }), /* @__PURE__ */ r(a.ItemIndicator, {
			className: "text-ic-web-primary-text absolute right-2 flex size-4 items-center justify-center",
			children: /* @__PURE__ */ r(t, { className: "size-4" })
		})]
	});
}
function d(e) {
	return /* @__PURE__ */ r(a.Group, {
		"data-slot": "select-group",
		...e
	});
}
function f({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.GroupLabel, {
		"data-slot": "select-group-label",
		className: e("text-ic-web-text-muted px-2 py-1.5 text-xs font-semibold", t),
		...n
	});
}
function p({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Separator, {
		"data-slot": "select-separator",
		className: e("bg-ic-web-border -mx-1 my-1 h-px", t),
		...n
	});
}
var m = {
	Root: o,
	Trigger: s,
	Value: c,
	Content: l,
	Item: u,
	Group: d,
	GroupLabel: f,
	Separator: p
};
//#endregion
export { m as Select };
